import axios from "axios";
import env from "../variables/EndpointEnvironment";

const StockAPI = () => {
  return axios.get(`${env.HOST}/informasi-saham`, {
    headers: {
      "Content-Language": localStorage.getItem('i18nextLng'),
    },
  });
};

export default StockAPI;